module.exports = __webpack_public_path__ + "static/list-b17f88046980b02e8c83452271307c8b.png";